export default __webpack_public_path__ + "static/media/plan-2.de27c78c.jpg";